import { CarrierRateChangeSetStatus } from "@redotech/crdb-enums/fulfillment/carrier-rate-change-set-status";
import * as z from "zod";
import { carrierRateChangeSetSchema } from "./carrier-rate-change-set";

export const listCarrierRateChangeSets = {
  name: "listCarrierRateChangeSets" as const,
  input: z.object({
    carrier: z.string().optional(),
    status: z.enum(CarrierRateChangeSetStatus).optional(),
  }),
  output: z.object({ changeSets: z.array(carrierRateChangeSetSchema) }),
};
